//
//
//
//
//
//
//

var numeral = require('numeral')

export default {
  prop: ['value'],
  data() {
    return {
      display: true,
      content: null
    }
  },
  watch: {
    value() {
      this.content = this.value
    }
  },
  mounted() {
    this.content = this.value
  },
  methods: {
    onEnter: function() {
      if(this.operatingSystem == 'android') {
       this.$refs.money.blur()
      }
    },
    submit() {

    },
    hideInput() {
      this.display = true
      this.$emit('input', numeral(this.content).value())
      //this.$emit('change', numeral(this.content).value())

      if(this.operatingSystem == 'android') {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
        }, 1000)
      }
    },
    showInput() {
      this.display = false
      this.content = null
      this.$nextTick(() => {
        this.$refs.money.focus()
      })
    },
    handleInput(e) {
      console.log('this.content', this.content, numeral(this.content).format('0.00'));
      if(_.endsWith(this.content, '.')) {
        return;
      }
        var countDecimals = function(num) {
          var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
          if (!match) { return 0; }
          return Math.max(
              0,
              // Number of digits right of decimal point.
              (match[1] ? match[1].length : 0)
              // Adjust for scientific notation.
              - (match[2] ? +match[2] : 0));
        }
const truncateByDecimalPlace = (value, numDecimalPlaces) =>
  Math.trunc(value * Math.pow(10, numDecimalPlaces)) / Math.pow(10, numDecimalPlaces)
      if(countDecimals(this.content) > 2) {
        this.content = truncateByDecimalPlace(numeral(this.content).value(),2)
      }
      if(countDecimals(this.content) == 1) {
        //this.content = numeral(this.content).format('0.00')
      }
      //this.content = numeral(this.content).format('0.00')
      //this.content = numeral(this.content).value()
      //this.$emit('input', this.content)
      this.$emit('input', numeral(this.content).value())

    }
  }
}
